

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as SchemaTypes from '../schema/types'

import * as ScraTypes from "./types"

export type LoanChangeTermsScraUpdateKey = ['people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type LoanChangeTermsScraUpdateResponse = ScraTypes.ResponseChangeScheduleScra;

export type LoanChangeTermsScraUpdateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLoanChangeLoanTermsScraUpdate;
    query?: void;
}

export const loanChangeTermsScraUpdate = makeData<
  LoanChangeTermsScraUpdateResponse,
  LoanChangeTermsScraUpdateKey,
  LoanChangeTermsScraUpdateVariables
>({
  method: 'put',
  name: 'loanChangeTermsScraUpdate',
  summary: "Change installment loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type LoanChangeTermsScraCreateKey = ['people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type LoanChangeTermsScraCreateResponse = ScraTypes.ResponseChangeScheduleScra;

export type LoanChangeTermsScraCreateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLoanChangeLoanTermsScra;
    query?: {
        sync?: boolean;
    };
}

export const loanChangeTermsScraCreate = makeData<
  LoanChangeTermsScraCreateResponse,
  LoanChangeTermsScraCreateKey,
  LoanChangeTermsScraCreateVariables
>({
  method: 'post',
  name: 'loanChangeTermsScraCreate',
  summary: "Create installment loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type LoanChangeTermsScraDeleteKey = ['people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type LoanChangeTermsScraDeleteResponse = void;

export type LoanChangeTermsScraDeleteVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        rateId: SchemaTypes.AnyId;
        /**
         * @default
         *     true
         */
        sendNotice?: boolean;
        caseId?: SchemaTypes.AnyId;
    };
}

export const loanChangeTermsScraDelete = makeData<
  LoanChangeTermsScraDeleteResponse,
  LoanChangeTermsScraDeleteKey,
  LoanChangeTermsScraDeleteVariables
>({
  method: 'delete',
  name: 'loanChangeTermsScraDelete',
  summary: "Delete installment loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type LocChangeTermsScraUpdateKey = ['people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type LocChangeTermsScraUpdateResponse = ScraTypes.ResponseLocChangeScheduleScra;

export type LocChangeTermsScraUpdateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLocChangeLoanTermsScraUpdate;
    query?: void;
}

export const locChangeTermsScraUpdate = makeData<
  LocChangeTermsScraUpdateResponse,
  LocChangeTermsScraUpdateKey,
  LocChangeTermsScraUpdateVariables
>({
  method: 'put',
  name: 'locChangeTermsScraUpdate',
  summary: "Change line of credit loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})

export type LocChangeTermsScraCreateKey = ['people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type LocChangeTermsScraCreateResponse = ScraTypes.ResponseLocChangeScheduleScra;

export type LocChangeTermsScraCreateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLocChangeLoanTermsScra;
    query?: {
        sync?: boolean;
    };
}

export const locChangeTermsScraCreate = makeData<
  LocChangeTermsScraCreateResponse,
  LocChangeTermsScraCreateKey,
  LocChangeTermsScraCreateVariables
>({
  method: 'post',
  name: 'locChangeTermsScraCreate',
  summary: "Create line of credit loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})

export type LocChangeTermsScraDeleteKey = ['people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type LocChangeTermsScraDeleteResponse = void;

export type LocChangeTermsScraDeleteVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        rateId: SchemaTypes.AnyId;
        /**
         * @default
         *     true
         */
        sendNotice?: boolean;
        caseId?: SchemaTypes.AnyId;
    };
}

export const locChangeTermsScraDelete = makeData<
  LocChangeTermsScraDeleteResponse,
  LocChangeTermsScraDeleteKey,
  LocChangeTermsScraDeleteVariables
>({
  method: 'delete',
  name: 'locChangeTermsScraDelete',
  summary: "Delete line of credit loan terms SCRA",
  path: '/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})

export type AliasLoanChangeTermsScraUpdateKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type AliasLoanChangeTermsScraUpdateResponse = ScraTypes.ResponseChangeScheduleScra;

export type AliasLoanChangeTermsScraUpdateVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLoanChangeLoanTermsScraUpdate;
    query?: void;
}

export const aliasLoanChangeTermsScraUpdate = makeData<
  AliasLoanChangeTermsScraUpdateResponse,
  AliasLoanChangeTermsScraUpdateKey,
  AliasLoanChangeTermsScraUpdateVariables
>({
  method: 'put',
  name: 'aliasLoanChangeTermsScraUpdate',
  summary: "Change installment loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type AliasLoanChangeTermsScraCreateKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type AliasLoanChangeTermsScraCreateResponse = ScraTypes.ResponseChangeScheduleScra;

export type AliasLoanChangeTermsScraCreateVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLoanChangeLoanTermsScra;
    query?: {
        sync?: boolean;
    };
}

export const aliasLoanChangeTermsScraCreate = makeData<
  AliasLoanChangeTermsScraCreateResponse,
  AliasLoanChangeTermsScraCreateKey,
  AliasLoanChangeTermsScraCreateVariables
>({
  method: 'post',
  name: 'aliasLoanChangeTermsScraCreate',
  summary: "Create installment loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type AliasLoanChangeTermsScraDeleteKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'payment-plan-scra',unknown];

export type AliasLoanChangeTermsScraDeleteResponse = void;

export type AliasLoanChangeTermsScraDeleteVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        rateId: SchemaTypes.AnyId;
        /**
         * @default
         *     true
         */
        sendNotice?: boolean;
        caseId?: SchemaTypes.AnyId;
    };
}

export const aliasLoanChangeTermsScraDelete = makeData<
  AliasLoanChangeTermsScraDeleteResponse,
  AliasLoanChangeTermsScraDeleteKey,
  AliasLoanChangeTermsScraDeleteVariables
>({
  method: 'delete',
  name: 'aliasLoanChangeTermsScraDelete',
  summary: "Delete installment loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'payment-plan-scra', query],
})

export type AliasLocChangeTermsScraUpdateKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type AliasLocChangeTermsScraUpdateResponse = ScraTypes.ResponseLocChangeScheduleScra;

export type AliasLocChangeTermsScraUpdateVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLocChangeLoanTermsScraUpdate;
    query?: void;
}

export const aliasLocChangeTermsScraUpdate = makeData<
  AliasLocChangeTermsScraUpdateResponse,
  AliasLocChangeTermsScraUpdateKey,
  AliasLocChangeTermsScraUpdateVariables
>({
  method: 'put',
  name: 'aliasLocChangeTermsScraUpdate',
  summary: "Change line of credit loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})

export type AliasLocChangeTermsScraCreateKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type AliasLocChangeTermsScraCreateResponse = ScraTypes.ResponseLocChangeScheduleScra;

export type AliasLocChangeTermsScraCreateVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: ScraTypes.RequestBodyLocChangeLoanTermsScra;
    query?: {
        sync?: boolean;
    };
}

export const aliasLocChangeTermsScraCreate = makeData<
  AliasLocChangeTermsScraCreateResponse,
  AliasLocChangeTermsScraCreateKey,
  AliasLocChangeTermsScraCreateVariables
>({
  method: 'post',
  name: 'aliasLocChangeTermsScraCreate',
  summary: "Create line of credit loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})

export type AliasLocChangeTermsScraDeleteKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'loc-payment-plan-scra',unknown];

export type AliasLocChangeTermsScraDeleteResponse = void;

export type AliasLocChangeTermsScraDeleteVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        rateId: SchemaTypes.AnyId;
        /**
         * @default
         *     true
         */
        sendNotice?: boolean;
        caseId?: SchemaTypes.AnyId;
    };
}

export const aliasLocChangeTermsScraDelete = makeData<
  AliasLocChangeTermsScraDeleteResponse,
  AliasLocChangeTermsScraDeleteKey,
  AliasLocChangeTermsScraDeleteVariables
>({
  method: 'delete',
  name: 'aliasLocChangeTermsScraDelete',
  summary: "Delete line of credit loan terms SCRA",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loc-payment-plan-scra',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'loc-payment-plan-scra', query],
})
